import { useSelector } from 'react-redux';
import { selectUser } from '../redux/reducers/userReducer';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useOnlyAdminAndCustomerUsers = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user.data?.user.user_id || user.data?.user.userType === 'normal') {
      navigate('/');
    }
    return () => {};
  }, [user.data?.user.user_id]);
};
